import * as S from './PropertyUnavailableUI.styles';

const defaultImageUrl =
  'https://go-assets.ibcdn.com/u/GI/images/1719378399175-property-unavailable.png';

const PropertyUnavailableUI = ({handlRedirectToSRPGOSuggest = () => {}, errorMessage = ''}) => {
  return (
    <S.Container>
      <S.ImageContainer>
        <S.ImageWrapper src={defaultImageUrl} alt="Not Available" />
      </S.ImageContainer>
      <S.Description>
        {errorMessage || 'This property is currently Not Available on Goibibo'}
      </S.Description>
      <S.ButtonWrapper onClick={handlRedirectToSRPGOSuggest}>
        View Similar Properties
      </S.ButtonWrapper>
    </S.Container>
  );
};

export default PropertyUnavailableUI;
